import type { Sucursal } from "@/types/user";

export interface SucursalDisplayResult {
  visible: Sucursal[];
  remaining: number;
  showAll: boolean;
}

/**
 * Computes which sucursales to display in the table column.
 * - Admin Global → showAll badge
 * - 0 sucursales → empty
 * - 1-2 sucursales → show all as badges
 * - 3+ sucursales → show first 2 + "+N" indicator
 */
export function getSucursalDisplay(
  sucursales: Sucursal[],
  isAdminGlobal: boolean,
  maxVisible = 2
): SucursalDisplayResult {
  if (isAdminGlobal) {
    return { visible: [], remaining: 0, showAll: true };
  }
  const visible = sucursales.slice(0, maxVisible);
  const remaining = Math.max(0, sucursales.length - maxVisible);
  return { visible, remaining, showAll: false };
}
